import { Component, Inject, Input, OnInit } from '@angular/core';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef, MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA} from '@angular/material/legacy-snack-bar';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit {
 
  constructor(
    private snackBarRef : MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data
  ) { }

  ngOnInit(): void {
  }
  // openSnackBar(message: string) {
  //   let config = new MatSnackBarConfig();
  // config.panelClass = ['custom-class'];
  //   this._snackBar.open(message, '<mat-icon>close</mat-icon>', config
  //   );
  // }
  close() {
    this.snackBarRef.dismiss();
  }

}
